import { render, staticRenderFns } from "./feeDetailMonthFee.vue?vue&type=template&id=148ada53"
import script from "./feeDetailMonthFee.vue?vue&type=script&lang=js"
export * from "./feeDetailMonthFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports